<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="baseRest">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()">基本信息</div></van-col>
      </van-row>
      <div class="baseRect">
        <div class="topTitle">订单信息<span :style="'color:'+GetDiveMainBack()">BOOKING</span></div>
        <van-row gutter="10" class="values">
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.diveOrderId;"
          >
            <span :style="'color:'+GetDiveMainBack()">行程号: </span>{{ data.diveOrder.diveOrderId }}
          </van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">潜水中心: </span>{{ data.diveStoreName }}</van-col>

        </van-row>

        <van-row gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">预订人: </span>{{ data.diveOrder.bookName }}</van-col>
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.bookEmail;"
          >
            <span :style="'color:'+GetDiveMainBack()">邮箱: </span>{{ data.diveOrder.bookEmail }}</van-col>
        </van-row>
        <van-row gutter="10" class="values">
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.bookPhone;"
          >
            <span :style="'color:'+GetDiveMainBack()">手机号码: </span>{{ data.diveOrder.bookPhone }}</van-col>
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.bookSocialMediaAccount;"
          >
            <span :style="'color:'+GetDiveMainBack()">社交媒体账号: </span>{{ data.diveOrder.bookSocialMediaAccount }}</van-col>
        </van-row>
        <van-row gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">订单创建: </span>{{ formatDate(data.diveOrder.craeteTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">最后修改: </span>{{ formatDate(data.diveOrder.lastTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
        </van-row>
        <van-row gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">预订人: </span>{{ data.diveOrder.createManageName }}</van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">最后修改: </span>{{ data.diveOrder.lastManageName }}</van-col>
        </van-row>
        <van-row gutter="10" class="values">
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.orderId;"
          >
            <span :style="'color:'+GetDiveMainBack()">商城订单号: </span>{{ data.diveOrder.orderId }}</van-col>
          <van-col
            v-clipboard:success="onCopySocialMediaAccount"
            v-clipboard:copy="copyStr"
            span="12"
            @click="copyStr=undefined;copyStr= data.diveOrder.outOrderId;"
          >
            <span :style="'color:'+GetDiveMainBack()">外部订单号: </span>{{ data.diveOrder.outOrderId }}</van-col>
        </van-row>
        <van-row class="values">
          <van-col span="24"><span :style="'color:'+GetDiveMainBack()">备注: </span>{{ data.diveOrder.remark }}</van-col>
        </van-row>
        <van-row class="values">
          <van-col span="24"><span :style="'color:'+GetDiveMainBack()">私密备注: </span>{{ data.diveOrder.remarkPrivate }}</van-col>
        </van-row>
      </div>
      <div class="baseRect">
        <div class="topTitle">费用<span :style="'color:'+GetDiveMainBack()">COST</span></div>
        <van-row gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">已付款: </span>{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.payPrice) }}</b></van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">总金额: </span>{{ data.diveOrder.currency }} <b>{{ ShowMoney(data.diveOrder.totalPrice) }}</b></van-col>
        </van-row>
        <van-row class="values">
          <van-col span="24"><span :style="'color:'+GetDiveMainBack()">款项: </span>
            <van-tag v-if="0.01 > Math.abs(data.diveOrder.totalPrice - data.diveOrder.payPrice)" :color="GetDiveMainBack()">已结清</van-tag>
            <van-tag v-if="data.diveOrder.totalPrice < data.diveOrder.payPrice" :color="GetDiveMainBack()">已结清 多支付{{ data.diveOrder.currency }} {{ ShowMoney(data.diveOrder.payPrice - data.diveOrder.totalPrice) }}</van-tag>
            <van-tag v-if="data.diveOrder.totalPrice > data.diveOrder.payPrice" type="warning">{{ data.diveOrder.currency }} {{ ShowMoney(data.diveOrder.totalPrice - data.diveOrder.payPrice) }} 未结清</van-tag>
          </van-col>
        </van-row>
      </div>
    </div>
    <div v-if="data" class="baseRest">
      <van-row>
        <van-col span="12"><div :style="'color:'+GetDiveMainBack()">订单顾客行程</div></van-col>
      </van-row>
      <table class="tableRect" style="margin-top:1em" cellspacing="0">
        <tr class="title" :style="'color:'+GetDiveMainBack()">
          <td>姓名</td>
          <td>课程</td>
          <td>教练</td>
          <td>状态</td>
        </tr>
        <tr v-for="member in data.member" :key="member.studentId">
          <td>{{ member.loaclName }}</td>
          <td>{{ member.diveCourseName?member.diveCourseName:'-' }}</td>
          <td>{{ member.coachName?member.coachName:'-' }}</td>
          <td>{{ GetEnumText('Em_LearningState',member.state) }}</td>
        </tr>
      </table>
    </div>
    <div v-if="data" class="baseRest">
      <van-row style="margin-bottom:1em">
        <van-col span="12"><div :style="'color:'+GetDiveMainBack()">行程订单日志</div></van-col>
        <van-col span="12" class="rigth">
          <i class="iconfont iconadd" @click="onShowAddDiveOrderLog" />
        </van-col>
      </van-row>
      <div v-for="log in data.logList" :key="log.diveOrderLogId" class="LogRect">
        <van-tag v-if="log.isPublic" plain type="success" style="margin-right:0.5em;">公开</van-tag>
        <van-tag v-if="!log.isPublic" plain type="danger" style="margin-right:0.5em;">私密</van-tag>
        <van-tag v-if="log.userId" mark :color="GetDiveMainBack()">{{ log.userName }}</van-tag>
        <van-tag v-if="log.coachId" mark type="primary" :closeable="log.coachId===userData.proAccountId && !log.isDelete" @close="onDeleteDiveOrderLog(log.diveOrderLogId)">{{ log.userName }}教练</van-tag>
        <van-tag v-if="log.manageUserId" mark type="warning">{{ log.userName }}管理员</van-tag>
        <span v-if="!log.isDelete" class="data">{{ log.body }}</span>
        <span v-if="log.isDelete" class="data"><del>{{ log.body }}</del></span>
        <span v-if="!log.isDelete" class="date">{{ formatDate(log.createTime,"yyyy/MM/dd hh:mm",true) }}</span>
        <span v-if="log.isDelete" class="date"><del>{{ formatDate(log.createTime,"yyyy/MM/dd hh:mm",true) }}</del></span>
      </div>
    </div>
    <mgrDiveOrderLogView v-model="showAddDiveOrderLog" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Dialog, Button, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { getUserBase, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import mgrDiveOrderLogView from '@/views/pro/trip/mgrDiveOrderLogView'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Tag.name]: Tag,
    TopBar,
    mgrDiveOrderLogView
  },
  data() {
    return {
      titleTop: '',
      title: '行程订单详情',
      backurl: '/dive',
      diveOrderId: undefined,
      userData: undefined,
      data: undefined,
      copyStr: undefined,
      showAddDiveOrderLog: undefined,
      buttonLoading: false
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.diveOrderId = this.$route.params.id
    getUserBase((userData) => {
      this.userData = userData
      this.init()
    }, true)
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/DiveTrip/getDiveOrderCoach',
        method: 'post',
        params: { id: this.diveOrderId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.data = Response.data

        if (callback) {
          callback()
        }
      })
    },
    onCopySocialMediaAccount(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    onShowAddDiveOrderLog() {
      this.showAddDiveOrderLog = this.diveOrderId
    },
    onDeleteDiveOrderLog(id) {
      Dialog.confirm({
        title: '删除行程日志',
        message: '是否要删除行程日志?已删除日志除用户外依然可见!'
      }).then(() => {
        this.onDeleteDiveOrderLogDo(id)
      })
    },
    onDeleteDiveOrderLogDo(id) {
      this.buttonLoading = true
      request({
        url: '/DiveTrip/deleteDiveOrderCoachLog',
        method: 'post',
        params: { id: id }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '删除成功', 2000)
        this.init()
      })
    }
  }
}
</script>
<style scoped>
.baseRest{
    background-color: #fff;
    margin-bottom: 0.5em;
    padding: 1em 1em;
}
.baseRest .title{
    margin-bottom: 0.5em;
}
.baseRect .values{
  font-size: 0.8em;
  padding: 0.25em 0;
}
.baseRect .topTitle{
  font-size: 0.9em;
  padding: 0.25em 0;
  font-weight: 700;
}
.baseRect .topTitle span{
  margin-left: 0.5em;
}
 .tableRect{
  width: 100%;
  font-size: 0.8em;
}
 .tableRect td{
  border:1px solid #fafafa;
  padding: 0.25em;
}

 .tableRect .title{
  text-align: center;
}

 .LogRect{
    margin-bottom: 0.25em;
    padding-bottom: 0.25em;
    border-bottom: 1px solid #f5f5f5;
}
 .LogRect:last-child{
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
}
 .LogRect .data{
    font-size: 0.8em;
    margin-left: 0.5em;
}
 .LogRect .date{
    font-size: 0.8em;
    color: #999;
    margin-left: 0.5em;
}
</style>
